<template>
  <h4 class="col-12 part-title text-left">
    <slot></slot>
  </h4>
</template>

<script>

export default {

}
</script>
